import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { WEATHER_API, SUNNY, PARTLY_SUNNY, PARTLY_CLOUDY, CLOUDY_DAY, WINDY, LIGHT_RAIN, RAINY, STORMY, CLEAR, CLOUDY_NIGHT, HIGH_WIND } from './constants';

export const conditionsApi = createApi({
	reducerPath: 'conditionsApi',
	baseQuery: fetchBaseQuery({ baseUrl: WEATHER_API}),
	endpoints: (build) => ({
		getWeather: build.query({
			query: () => `gridpoints/MOB/111,57/forecast/hourly`,
			transformResponse: (response) => {
				const conditions = {
					'mostly sunny': PARTLY_SUNNY,
					'partly sunny': PARTLY_SUNNY,
					sunny: SUNNY,
					fair: PARTLY_SUNNY,
					'partly cloudy': PARTLY_CLOUDY,
					'variable clouds': PARTLY_CLOUDY,
					'fog': CLOUDY_DAY,
					cloudy: CLOUDY_DAY,
					overcast: CLOUDY_DAY,
					'mostly cloudy': CLOUDY_DAY,
					'/windy/': WINDY,
					'/slight chance rain/': LIGHT_RAIN,
					'/scattered showers/': LIGHT_RAIN,
					rainy: RAINY,
					'/chance showers/': RAINY,
					'/showers likely/': RAINY,
					'/isolated showers/': RAINY,
					stormy: STORMY,
					thunderstorms: STORMY,
					storms: STORMY,
					storm: STORMY,
					'mostly clear': CLOUDY_NIGHT,
					clear: CLEAR,
				}
				if (!Array.isArray(response.properties?.periods))return null;
				let forecast = response.properties?.periods[0].shortForecast.toLowerCase();
				const isDaytime = response.properties?.periods[0].isDaytime;
				const windSpeed = parseInt(response.properties?.periods[0].windSpeed);
				let icon;
				const keys = Object.keys(conditions);
				for (const key of keys) {
					if (icon)continue;
					if (key.charAt(0) === '/' && key.charAt(key.length-1) === '/') {
						const regex = new RegExp(key.substr(1, key.length-2), 'i');
						if (regex.test(forecast))icon = conditions[key];
					} else {
						if (forecast.includes(key))icon = conditions[key];
					}
				}
				if (icon === undefined && isDaytime)icon = (isDaytime ? conditions.sunny : conditions.clear);
				if (icon === conditions.SUNNY && windSpeed >= HIGH_WIND)icon = WINDY;
				return {
					temperature: response.properties?.periods[0].temperature,
					forecast: response.properties?.periods[0].shortForecast,
					icon: icon,
				}
			}
		}),
	}),
});

export const { useGetWeatherQuery } = conditionsApi;

/*
const initialState = {
	data: null,
	status: 'idle',
	error: null,
}

export const fetchInitialData = createAsyncThunk(
	'conditions/fetchInitialData',
	async () => {
		let response;
		try {
			response = await fetch('https://api.weather.gov/gridpoints/MOB/111,57/forecast/hourly');
		}
		catch (err) {
			return null;
		}
		const json = await response.json();
		if (!Array.isArray(json.properties?.periods))return null;
		console.log(json.properties.periods[0]);
		return {
			temperature: json.properties?.periods[0].temperature,
			forecast: json.properties?.periods[0].shortForecast,
		}
	}
)

export const conditionsSlice = createSlice({
	name: 'conditions',
	initialState,
	reducers: {
		// setFlag: (state, action) => {
		// 	state.locked = action.payload;
		// },
	},
	extraReducers: (builder) => {
		builder
			.addCase(fetchInitialData.pending, (state) => {
				console.log(fetchInitialData);
				console.log(state);
				state.status = 'loading';
			})
			.addCase(fetchInitialData.fulfilled, (state, action) => {
				console.log(fetchInitialData);
				console.log(state);
				console.log(action);
				state.status = 'succeeded';
				state.data = action.payload;
			})
			.addCase(fetchInitialData.rejected, (state, action) => {
				console.log(fetchInitialData);
				console.log(state);
				console.log(action);
				state.status = 'failed';
				state.error = action.error?.message;
			});
	}
});

export const { setFlag } = conditionsSlice.actions;

export default conditionsSlice.reducer;
*/